// WHITE-LABEL: ROUTE PRESENTATION
// This is the single module-to-layout map for the plain-admin template.
// A replacement template can interpret the same route groups differently.
const bareRoutes = new Set([
  "home", "loading", "login", "logout", "sandbox", "setup", "utility",
]);

const routeGroups = Object.freeze({
  system: Object.freeze(["settings", "activity", "help", "adder", "bypass", "about"]),
  clients: Object.freeze([
    "client", "clientView", "private", "privateView", "privateAdd", "public", "publicAdd",
    "retail", "retailView", "tpa", "tpaView", "tpaAdd",
  ]),
  network: Object.freeze([
    "hospital", "provider", "providerSync", "providerView", "providerAdd",
    "tariffMini", "tariffMiniView", "tariffPlus", "tariffPlusView",
  ]),
  claims: Object.freeze([
    "claim", "claimView", "claimAdd", "auth", "authView", "authAdd", "enrollee", "enrolleeAdd",
  ]),
  review: Object.freeze(["advisory", "supervisor", "hod", "compliance"]),
  finance: Object.freeze(["finance", "payment", "report"]),
  care: Object.freeze(["billing", "billingView", "list", "encounter", "encounterAdd", "users"]),
  company: Object.freeze(["members", "invoices", "contract", "healthcare", "profiles"]),
  member: Object.freeze(["medical", "history", "benefits", "profile"]),
});

const routeGroupByName = Object.freeze(
  Object.entries(routeGroups).reduce((lookup, [group, names]) => {
    names.forEach((name) => { lookup[name] = group; });
    return lookup;
  }, {})
);

const routeKind = (name) => {
  if (/Add$/.test(name) || name === "adder") return "create";
  if (/View$/.test(name)) return "detail";
  if (/Sync$/.test(name)) return "sync";
  if (["settings", "activity", "help", "about", "report"].includes(name)) return "workspace";
  return "registry";
};

const routePresentation = (route) => {
  const name = String(route?.name || "unknown");
  const override = route?.meta?.plainAdmin || {};
  const framed = override.framed ?? !bareRoutes.has(name);

  return Object.freeze({
    framed,
    group: override.group || routeGroupByName[name] || (framed ? "system" : "bare"),
    kind: override.kind || (framed ? routeKind(name) : "bare"),
    name,
  });
};

export { bareRoutes, routeGroups, routePresentation };
export default routePresentation;
